// extracted by mini-css-extract-plugin
module.exports = {"FOOTER":"footer-module--FOOTER--3LOzA"};